import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  size: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
}

const defaultProps = {
  tag: 'div',
}

const InputGroup = props => {
  const { className, cssModule, tag: Tag, size, ...attributes } = props
  const classes = classNames(className, 'input-group', size ? `input-group-${size}` : null)

  return <Tag {...attributes} className={classes} />
}

InputGroup.propTypes = propTypes
InputGroup.defaultProps = defaultProps

export default InputGroup



// WEBPACK FOOTER //
// ./ui/Input/InputGroup.js